import { withRef } from '@udecode/cn';
import { PlateElement } from '@udecode/plate/react';
import { filterWords } from '@udecode/plate-combobox';
import { getMentionOnSelectItem } from '@udecode/plate-mention';
import { useCallback, useState } from 'react';

import { useCitationList } from '../../hooks/useCitationList.hook';
import { type FilterFn,InlineCombobox, InlineComboboxContent, InlineComboboxEmpty, InlineComboboxGroup, InlineComboboxInput, InlineComboboxItem } from '../common/inlineComboBox.component';

const onSelectItem = getMentionOnSelectItem();

const filterFn: FilterFn = ({ value, group, label, keywords = [] }, search) => {
    if (value === '__new__') {
        return true;
    }

    const uniqueTerms = new Set(
        [value, ...keywords, group, label].filter(Boolean)
    );

    return Array.from(uniqueTerms).some((keyword) =>
        filterWords(keyword!, search)
    );
};

export const MentionInputElement = withRef<typeof PlateElement>(
    ({ className, ...props }, ref) => {
        const { citationList, addCitation } = useCitationList();

        const { children, editor, element } = props;
        const [search, setSearch] = useState('');

        const handleSelectItem = useCallback((key: string, label: string) => {
            if (key === '' && label != '') {
                const { id: key } = addCitation(label);
                onSelectItem(editor, { key, text: key }, search);
            } else {
                onSelectItem(editor, { key, text: key }, search);
            }
        }, [ editor, search ]);

        return (
            <PlateElement
                ref={ref}
                as="span"
                className={className}
                data-slate-value={element.value}
                {...props}
            >
                <InlineCombobox
                    value={search}
                    element={element}
                    setValue={setSearch}
                    filter={filterFn}
                    showTrigger={false}
                    trigger="@"
                >
                    <span className="inline-block rounded-md bg-muted px-1.5 py-0.5 align-baseline text-sm ring-ring focus-within:ring-2 min-w-8 bg-gray-200">
                        <InlineComboboxInput />
                    </span>
                    <InlineComboboxContent className="my-1.5">
                        <InlineComboboxEmpty>(nenalezeno)</InlineComboboxEmpty>
                        <InlineComboboxGroup>
                            {citationList.map(([ key, item ]) => (
                                <InlineComboboxItem
                                    key={key}
                                    value={item.userLabel}
                                    onClick={() => handleSelectItem(key, item.userLabel)}
                                >
                                    {item.userLabel}
                                </InlineComboboxItem>
                            ))}
                            {search !== '' && (
                                <InlineComboboxItem
                                    value={'__new__'}
                                    onClick={() => handleSelectItem('', search)}
                                >
                                Vytvořit: {search}
                                </InlineComboboxItem>
                            )}
                        </InlineComboboxGroup>
                    </InlineComboboxContent>
                </InlineCombobox>
                {children}
            </PlateElement>
        );
    }
);
